import { render, staticRenderFns } from "./VacationCommentField.vue?vue&type=template&id=3a63043c&"
import script from "./VacationCommentField.vue?vue&type=script&lang=js&"
export * from "./VacationCommentField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a63043c')) {
      api.createRecord('3a63043c', component.options)
    } else {
      api.reload('3a63043c', component.options)
    }
    module.hot.accept("./VacationCommentField.vue?vue&type=template&id=3a63043c&", function () {
      api.rerender('3a63043c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employee/permission/vacations/fields/VacationCommentField.vue"
export default component.exports